import CancelledSubscriptionConfirmModalComponent from "./CancelledSubscriptionConfirmModalComponent";

export default CancelledSubscriptionConfirmModalComponent;